import { render, staticRenderFns } from "./QuoteFreightTemplateList.vue?vue&type=template&id=ac029946&"
import script from "./QuoteFreightTemplateList.vue?vue&type=script&lang=ts&"
export * from "./QuoteFreightTemplateList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports